import { PMS_ENDPOINT } from 'src/configs/API'
import useSWR from 'swr'

import axios from 'axios'
const fetcher = (url) => axios.get(url).then((res) => res.data)

export const usePostOffices = () => {
	const { data, error } = useSWR(
		// `${PMS_ENDPOINT}${APIConstants.API_GET_LIST_POST_OFFICE}`,
		`${PMS_ENDPOINT}/MasterData/GetPublicPostOffices`,
		fetcher,
		{
			dedupingInterval: 1200000,
		}
	)

	return {
		postOffices: data?.data,
		isLoading: !error && !data,
		isError: error,
	}
}
